





























































































import { Component, Prop } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import { MessagingModule } from '@/store/modules/messaging';
import BookingRoleWorkerShifts from '@/components/BookingRoleWorkerShifts/Display/BookingRoleWorkerShifts.vue';
import BookingStatus from '@/components/Bookings/Display/BookingStatus.vue';
import BookingRoleWorkerDto from '@/models/BookingRoleWorkers/BookingRoleWorkerDto';

@Component({
  name: 'BookingRoleWorkerMessagingSummary',
  components: { BookingRoleWorkerShifts, BookingStatus }
})
export default class extends GiganautVue {

	@Prop({required: true})
	bookingRoleWorkerSummary: BookingRoleWorkerDto;


	// get bookingRoleWorkerSummary() {
	// 	return MessagingModule.bookingRoleWorkerSummary;
	// }

}
